import { useEffect, useState } from "react"
import fetchApi from "../api/fetchApi";
import RoomFilter from "../Components/RoomFilter/RoomFilter";
import queryString from 'query-string';
import RoomItem from "../Components/RoomItem/RoomItem";
import NothingMatches from "../Components/NothingMatches";
import { debounce } from "underscore";
import Loading from "../Components/Loading/Loading";
import CurrentRoom from "../Floors/Components/CurrentRoom/CurrentRoom";
import { Context } from "../App";
import { useContext } from "react";
import { emptyRoomChecker } from "../Components/EmptyRoomChecker";

const API = {
    "default": "estate/filter/flat?",
    "offices": "estate/page/sale/filter/flat?",
    "commercial": "commercial/filter/office?"
};

export default function Flats () {
    const {
        initialProps, 
        facilityId,
        containersType
    } = useContext(Context);
    
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [savedParams, setSavedParams] = useState({});
    const [ableLoad, setAbleLoad] = useState(true);

    const [flats, setFlats] = useState([]);
    const [apartment, setApartment] = useState();
    const [rooms, setRooms] = useState([]);


    const fetchFlats = async (params) => {
        setLoading(true);
        const {json, error} = await fetchApi(API[containersType] + queryString.stringify(params));
        setLoading(false);
    
        error && setError(error);
        
        if (!json) return setFlats([]);
        
        const flatList = json.results.map(flat => flat[0]);
        setFlats(flatList);
        setAbleLoad(true);
    }

    const loadMoreFlats = async () => {
        setLoading(true);
        const {json, error} =  await fetchApi(
            API[containersType] + queryString.stringify({...savedParams, step: flats.length})
        );
        setLoading(false);
    
        error && setError(error);
        
        if (!json) return setFlats([flats]);
        
        const flatList = json.results.map(flat => flat[0]);
        setFlats([...flats, ...flatList ]);
        if (!flatList.length) {
            setAbleLoad(false);
        }
    }


    useEffect(() => {
        const params = {
            "room[]": [0, 1, 2, 3, 4, 5, 6, 100],
            square: 1000000,
            price: 1000000000000,
            facility_id: containersType == "offices" ? undefined : facilityId,
        };

        setSavedParams(params);
    }, [containersType, facilityId]);

    
    useEffect(() => {
        const isEmpty = (obj) => {
            for (let keys in obj) return false;
            return true;
        };
        if (isEmpty(initialProps)) {
            return;
        }
        const rooms = [...initialProps.rooms];
        const roomsFree = [...initialProps.roomsFree];

        const floors = rooms?.map(({rooms}, index) => {
            const roomKey = rooms;
            return {
                countFree: roomsFree.find(({rooms}) => rooms === roomKey)?.count_free,
                rooms,
            };

        })
        
        setRooms(floors);
    }, [initialProps]);

    
    const handleFilterChange = debounce((data) => {
        const params = { 
            "room[]": [],
            square: null,
            price: null,
        };

        Object.entries(data.room).forEach(value => {
            value[1] && value && params["room[]"].push(value[0])
        })

        params.price = data.price;
        params.square = data.square;
        params.facility_id = facilityId;

        setSavedParams(params);
        fetchFlats(params);
    }, 1000);



    if (error) {
        return <NothingMatches>Произошла ошибка запроса, обновите страницу или попробуйте позже</NothingMatches> 
    }

    if (apartment) return (
        <>
            <button className="floors-control__button" onClick={() => setApartment()}>&#8592; Назад</button>
            <CurrentRoom 
                currentRoom={{id: apartment, type: "flat"}} 
                setLoading={setLoading}
            />
        </>
    );
    const isEmpty = emptyRoomChecker(rooms);

    return (
        <>
            { loading && <Loading /> }
            <RoomFilter 
                rooms={rooms}
                handleChange={handleFilterChange} 
                priceFilter={[initialProps.roomFilters?.min_price, initialProps.roomFilters?.max_price]}
                areaFilter={[initialProps.roomFilters?.min_area, initialProps.roomFilters?.max_area]}
                type="flat"
            />
            { !flats.length && !loading && isEmpty && <NothingMatches>Ничего не найдено</NothingMatches> }
            { 
                flats.length > 0 && 
                flats.map((flat, key) => <RoomItem onClick={setApartment} data={flat} key={key} type="кв" />) 
            }
            {
                ableLoad && flats.length > 0 &&
                <div className="room__load-more" onClick={loadMoreFlats}>
                    <a className="show">Загрузить еще</a>
                </div>
            }
        </>
    )
}